import ComingSoon from '@/components/ComingSoon';

const Marketing = () => {
    return (
        <ComingSoon />
    );
};

export default Marketing;
